import dayjs from "dayjs";

import { formatDateLocale } from "@/shared/utils/formatDate";
import { colors } from "@/Utils";
import { getMetricsGraphsColor } from "@/Utils/Colors/GenerateColor";

export const INIT_FEED_DATA = {
  legendLabel: [],

  seriesData: [],
  initSelectedArray: [],
  date: [],

  tableHeaders: [],
  tableRows: [],
};

export const handleSourceData = ({ sourceData, setFeedData }) => {
  try {
    if (sourceData?.date) {
      const date = sourceData.date.map((date) =>
        formatDateLocale(dayjs(date), { yearFormat: "YY" })
      );
      let legendLabel = [];

      let seriesData = [];
      let initSelectedArray = {};

      const metricNames = Object.keys(sourceData.brand_metric).filter(
        (name) => name.toLowerCase() !== "intercept"
      );
      const allMetricColors = getMetricsGraphsColor({ metrics: metricNames });

      metricNames.forEach((stackName) => {
        const name = stackName;

        const { color, borderColor } = generateLegendColor({
          name: name,
          allMetricColors: allMetricColors,
        });

        legendLabel.push({
          name: stackName,

          itemStyle: {
            color,
            borderColor,
            borderWidth: 2,
          },
        });

        const data = date.map((dateVal, index) => {
          return {
            name: dateVal,
            value: sourceData.brand_metric[name][index],
            itemStyle: {
              color,
              borderColor,
              borderWidth: 2,
            },
            symbol: "circle",
            symbolSize: 4,
          };
        });

        seriesData.push({
          label: stackName,
          name: stackName,
          type: "line",
          fill: true,
          lineTension: 0,
          borderWidth: 2,
          borderCapStyle: "butt",
          pointHoverBorderWidth: 2,
          pointBorderWidth: 1,
          pointHitRadius: 10,
          data: data,
          barMaxWidth: 40,
          lineStyle: {
            color: color,
          },
        });
        initSelectedArray[stackName] = true;
      });

      setFeedData({
        legendLabel,
        seriesData,
        initSelectedArray,
        date,
      });
    }
  } catch (error) {
    setFeedData(INIT_FEED_DATA);
  }
};

/**
 *
 * @param {*} param0
 * @returns
 */
const generateLegendColor = ({ name, allMetricColors }) => {
  let color = colors.black;
  let borderColor = colors.black;

  try {
    color = allMetricColors.fill.filter((item) => item.name === name)[0].color;
    borderColor = allMetricColors.border.filter((item) => item.name === name)[0].color;
  } catch (error) {
    // pass
  }
  return { color: color, borderColor: borderColor };
};
